import React, { Fragment, h } from "preact";
import {connect} from "react-redux";
import {AppPage} from "../_common/components/app-page";
import PendingInviteComponent from './pages/PendingInviteComponent'
import {
  createReferralCode,
  fetchAddressInviteFriend,
  fetchInviteFriendStatus,
  fetchReferralCode
} from "../_rx/inviteFriend/actions";
import {useEffect} from "preact/hooks";
import SentInviteComponent from "./pages/SentInviteComponent";
import {t} from "../_i18n";
import {CF, FR} from "../_common/layout";
import {useHistory} from "react-router-dom";
import PromoInviteComponent from "./pages/PromoInviteComponent";

function InviteFriend ({inviteFriendStatus, fetchInviteFriendStatus}) {
    const history = useHistory();
    const showBackButton = history?.action !== 'POP'

    useEffect(() => {
        fetchInviteFriendStatus()
    }, [])

    return (
        <CF className="max-width">
            {showBackButton && <div className="back breadcrumb-item cursor-pointer d-none sm-d-block" onClick={history.goBack}>
                ← {t('Volver')}
            </div>}
            <h1 className='hero'>{t('Recomienda iLERNA')}</h1>

            <FR>
                <PromoInviteComponent />
            </FR>

            {/*{ inviteFriendStatus &&*/}
            {/*    <FR>*/}
            {/*        <PendingInviteComponent />*/}
            {/*        { inviteFriendStatus?.invites?.length > 0 &&*/}
            {/*            <h2 className='m-bottom m-top-x2'>{t('Invitaciones enviadas')}</h2>*/}
            {/*        }*/}

            {/*        { inviteFriendStatus?.invites?.length > 0 &&*/}
            {/*            inviteFriendStatus.invites.map(invite => <SentInviteComponent invite={invite}/>)*/}
            {/*        }*/}
            {/*    </FR>*/}

            {/*}*/}
        </CF>
    )
}


InviteFriend = connect(
    ({inviteFriendStatus})=>({inviteFriendStatus: inviteFriendStatus.status}),
    {fetchInviteFriendStatus})(InviteFriend);


export default ({...rest}) => (
    <AppPage
        className="max-width">
        <InviteFriend {...rest}/>
    </AppPage>
)
